import React from 'react'
import { Modal } from 'uiComponents/popups/modal.new'
import { DiscountCodeForm, discountCodeFormatter } from '../_shared'
import { useGetDiscountCodeDetailsQuery } from 'discounts/reduxQuery'
import { removeHash } from 'utils/hash'
import { DiscountCodeFormSchema } from '../_shared'
import { showSuccessMessage } from 'uiComponents/message'
import '../_shared/modal.scss'
import { useTranslation } from 'translations'

interface editDiscountModalProps {
    codeUuid: string
    poolUuid: string
    accountSlug: string
}

export const EditDiscountModal = ({ codeUuid, poolUuid, accountSlug }: editDiscountModalProps) => {
    const { t } = useTranslation()
    const { data: discount } = useGetDiscountCodeDetailsQuery({ accountSlug, poolUuid, codeUuid })
    const formattedDiscount = discountCodeFormatter.toForm(discount)

    const afterSubmit = (discount: DiscountCodeFormSchema) => {
        removeHash()
        showSuccessMessage(t('discounts.editDiscount.updatedSuccess', { code: discount.code }))
    }

    const title =
        formattedDiscount.type === 'product'
            ? t('discounts.editDiscount.editProductTitle')
            : t('discounts.editDiscount.editCartTitle')

    return discount ? (
        <Modal onDismiss={removeHash} title={title} className="edit-discount-modal">
            <DiscountCodeForm
                discount={formattedDiscount}
                discountType={formattedDiscount.type}
                onCancel={removeHash}
                afterSubmit={afterSubmit}
            />
        </Modal>
    ) : null
}
